// index.ts
// Sample
import PageTest from 'wp-content/themes/ap_vue_base_theme/src/pages/sample/page-test.vue';
// End of Sample
import PageHome from 'wp-content/themes/ap_vue_base_theme/src/pages/page-home.vue';
import Page404 from 'wp-content/themes/ap_vue_base_theme/src/pages/page-404.vue';
import Single from 'wp-content/themes/ap_vue_base_theme/src/pages/single.vue';
import PageContactUs from 'wp-content/themes/ap_vue_base_theme/src/pages/page-contact-us.vue';
export default {
  // Sample
  'page-test': PageTest,
  // End of Sample
  'page-home': PageHome,
  'page-404': Page404,
  'single': Single,
  'page-contact-us': PageContactUs,
};
